var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.is_valid_component)?_c('div',{staticClass:"profile-detail",class:_vm.el},[_c(_vm.el,{tag:"component"})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }